/*
 * @Descripttion: 图表mixins
 * @Author: zhanghang
 * @Date: 2021-07-27 14:01:59
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-04-13 16:27:45
 */
export default {
  props: {
    slots: {
      type: Array,
      default() {
        return [{ name: "default", controls: [] }];
      }
    },
    //数据源default:[satatic][interface]
    dataType: {
      type: String,
      default: "static"
    },
    //chart对象 字符串形式
    chartString: {
      type: String,
      default: ""
    },
    //动态数据路径
    dataURL: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "100%"
    },
    // 设置 请求时候添加的附加数据函数
    configAttachRequestParams: {
      type: Array,
      default() {
        return [];
      }
    },
    height: {
      type: String,
      default: "300px"
    }
  },
  watch: {
    width() {
      this.$nextTick(() => {
        this.chartObj && this.chartObj.resize();
      });
    },
    height: {
      handler(v) {
        if (this.isDesign) {
          let height = v;
          if (!v) {
            height = "auto";
          }
          if (dsf.isNumber(height)) {
            height += "px";
          }
          this.$dispatch("design-height-change", height);
        }
        this.$nextTick(() => {
          this.chartObj && this.chartObj.resize();
        });
      },
      immediate: true
    },
    //数据来源类型
    dataType() {
      this.$nextTick(() => {
        this.init(true);
      });
    },
    //动态数据地址
    dataURL() {
      this.$nextTick(() => {
        this.init();
      });
    },
    //图表配置项
    chart: {
      handler(val) {
        this.$nextTick(() => {
          this.reset();
        });
      },
      deep: true
    },
    excelData: {
      handler(res) {
        if (this.isDesign) {
          this.dataExcelAnalysis(res);
        }
      },
      deep: true
    }
  },
  data() {
    return {
      // 图表对象
      chartObj: null
    };
  },
  created() {
    // chartstring 获取 chartstring 作为chart
    if (this.chartString) {
      let chartString = this.chartString;
      let tmp = `(function () {
        return ${chartString}
      })()`;
      this.$emit("update:chart", eval(tmp));
    }
  },
  mounted() {
    this.loadCharts(this)
      .then(() => {
        if (typeof this.beforeInit === "function") {
          this.beforeInit();
        } else {
          this.init();
        }
      })
      .catch((ex) => {
        dsf.error(ex);
      });
  },
  beforeDestroy() {
    this.chartObj && this.chartObj.dispose();
    dsf?.emit?.$remove?.("loadCharts", this);
  },
  methods: {
    objectTostring(o, level) {
      if (o === null) {
        return "null,\n";
      } else if (typeof o === "string") {
        return `'${o}',\n`;
      } else if (typeof o === "function") {
        return o.toString() + ",";
      } else if (Array.isArray(o)) {
        let val = `[
          `;
        o.forEach((it) => {
          val += `${this.objectTostring(it)}`;
        });
        val += `]`;
        return `${val},\n`;
      } else if (typeof o === "object") {
        let val = `{
          `;
        Object.keys(o).forEach((key) => {
          val += `${key}:`;
          val += this.objectTostring(o[key]);
        });
        val += `}`;
        if (level) {
          return `${val}\n`;
        }
        return `${val},\n`;
      } else {
        return `${o},\n`;
      }
    },
    dataExcelAnalysis() {},
    loadCharts() {
      return dsf.chart
        .loadEcharts(this)
        .then(() => {
          let echarts = window.$echarts || window.echarts;
          this.chartObj = echarts.init(this.$refs["chart"]);
        })
        .catch((ex) => {
          throw ex;
        });
    },
    init() {
      if (!this.chartObj) return false;
      this.chartObj.showLoading({
        text: "正在加载数据"
      });

      // 接口形式
      if (this.dataType === "interface" && !this.isDesign) {
        //对数据进行拦截
        if (!this.dataURL) {
          this.$dispatch("interceptData", { options: this.chart, vm: this });
        } else {
          let params = this.getConfigAttachRequestParams();
          this.$http
            .get(this.$replace(this.dataURL, this.local), params)
            .done(({ success, data, message }) => {
              if (success) {
                return Promise.resolve(data);
              } else {
                this.$dispatch("httpError", { message: message, options: this.chart, vm: this });
                this.chartObj && this.chartObj.hideLoading();
              }
            })
            .then((data) => {
              if (data) {
                this.analysis(data);
              }
            })
            .error((err) => {
              this.$message((err && err.message) || "请求异常", false);
            });
        }
        // 数据源
      } else if (this.dataType === "datasource" && !this.isDesign) {
        if (this.dataURL) {
          this.$http
            .get(this.$replace(this.dataURL, this.local))
            .done(({ success, data }) => {
              if (success) {
                //数据源分析
                this.dataSourceAnalysis(data);
              }
            })
            .error((err) => {
              this.$message((err && err.message) || "请求异常", false);
            });
        } else {
          this.$message("数据源地址未配置", false);
        }
      } else if (this.dataType === "excel") {
        this.dataExcelAnalysis(this.excelData);
      } else {
        this.analysis();
      }
    },
    getConfigAttachRequestParams() {
      let params = {};
      this.configAttachRequestParams?.forEach((item) => {
        if (item.queryKey) {
          if (item.origin == "text") {
            params[item.queryKey] = item.valueKey;
          } else if (item.valueKey) {
            if (item.origin == "queryString") {
              if (this.queryString) {
                let param = this.$replace(item.valueKey, this.queryString);
                params[item.queryKey] = param || "";
              }
            } else if (item.origin == "cookie") {
              let cookiesobj = dsf.session.get();
              let param = this.$replace(item.valueKey, cookiesobj);
              params[item.queryKey] = param || "";
            } else if (item.origin == "localStorage") {
              let param = this.$replace(item.valueKey, localStorage);
              params[item.queryKey] = param || "";
            } else if (item.origin == "sessionStorage") {
              let param = this.$replace(item.valueKey, sessionStorage);
              params[item.queryKey] = param || "";
            } else if (item.origin == "vm") {
              if (this.$vm) {
                let param = this.$replace(item.valueKey, this.$vm);
                params[item.queryKey] = param;
              } else {
                params[item.queryKey] = "";
              }
            } else if (item.origin == "dialog") {
              if (this.$vm && this.$vm.dialogArgs) {
                let param = this.$replace(item.valueKey, this.$vm.dialogArgs);
                params[item.queryKey] = param;
              } else {
                params[item.queryKey] = "";
              }
            }
          }
        }
      });
      return params;
    },
    //重新请求数据，渲染
    resetByHttp(url, params) {
      return this.$http
        .get(url, params)
        .done(({ success, data }) => {
          if (success) {
            if (this.dataType === "datasource") {
              //数据源分析
              this.dataSourceAnalysis(data);
            } else {
              return Promise.resolve(data);
            }
          }
        })
        .then((data) => {
          if (data) {
            return this.analysis(data);
          }
        })
        .error((err) => {
          this.$message((err && err.message) || "请求异常", false);
        });
    },
    reset() {
      this.chartObj && this.chartObj.hideLoading();
      this.chartObj && this.chartObj.setOption(this.chart, true);

      setTimeout(this.resetCallback, 500);
    },
    resetCallback() {
      let chart = this.chartObj;

      try {
        chart.off("click");
      } catch (error) {
        console.log(error);
      }

      chart.on("click", (params) => {
        // echarts 点击事件
        if (this.$listeners["chart-click"]) {
          this.$dispatch("chart-click", params);
        }
      });
    },
    $resize() {
      setTimeout(() => {
        this.chartObj && this.chartObj.resize();
      }, 0);
    },
    resize() {
      setTimeout(() => {
        this.$resize();
      }, 500);
    }
  }
};
